import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Asset } from 'src/app/state-management';

@Injectable()
export class AssetService {

  headers: any;
  error: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  readonly assetsUrl = 'api/asset/';

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getAssets(): Observable<Asset[]> {
    return this.httpClient
      .get<Asset[]>(this.assetsUrl, this.httpOptions);
  }

  addAsset(asset: Asset): Observable<Asset> {
    return this.httpClient
      .post<Asset>(this.assetsUrl, asset, this.httpOptions);
  }

  deleteAsset(asset: Asset): Observable<Asset> {
    return this.httpClient
      .post<Asset>(this.assetsUrl + 'deleteasset', asset, this.httpOptions);
  }

}

